// Port of api/fuel/app/classes/insights/plays/duration.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'duration',
    insight: false,
    detail: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_plays()) return {}

        var range = this.get_period_date_range(type, owner, filter)
        var players = filter.players || 0
        var sqlPlayers = players ? ' AND p.play_players = ' + players : ''

        var plays = Util.queryFast(
            'SELECT p.play_length, SUM(p.play_count) AS play_count' +
            ' FROM play p' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.play_date >= ' + range.start +
            ' AND p.play_date < ' + range.end +
            ' AND p.play_length > 0' +
            sqlPlayers +
            ' GROUP BY p.play_length'
        )

        var duration = {}

        for (var i = 0; i < plays.length; i++) {
            var band = Math.ceil(parseInt(plays[i].play_length, 10) / 30)
            if (!duration[band]) duration[band] = 0
            duration[band] += parseInt(plays[i].play_count, 10)
        }

        return {
            duration: duration
        }

    }
})
